var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder } from '@angular/forms';
import { CustomerService } from '../services/customer.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheService } from '../../shared/services/cache.service';
import 'rxjs/add/operator/map';
import { Modal } from 'ngx-modal';
import { environment } from '../../../environments/environment';
var MemberDocumentsComponent = /** @class */ (function () {
    function MemberDocumentsComponent(_formBuilder, _customerService, sanitizer, _cacheService) {
        this._formBuilder = _formBuilder;
        this._customerService = _customerService;
        this.sanitizer = sanitizer;
        this._cacheService = _cacheService;
        this.documentUrl = [];
        this.memberResponseUrl = {};
    }
    MemberDocumentsComponent.prototype.ngOnInit = function () {
        this.getMemberDetails();
    };
    MemberDocumentsComponent.prototype.getMemberDetails = function () {
        var _this = this;
        this._customerService.getMemberDetails(this.fboid).subscribe(function (response) {
            var resLength = response.memberDocuments.length;
            var j = 0;
            var _loop_1 = function (i) {
                _this.documentUrl[i] = response.memberDocuments[i];
                _this.memberResponseUrl[i] = _this.documentUrl[i];
                if (response.memberDocuments[i].frontSideURL) {
                    _this.showFrontImg = true;
                    _this.documentUrl[i].frontSideURL = response.memberDocuments[i].frontSideURL;
                    _this.memberResponseUrl[i].frontSideURL = _this.documentUrl[i].frontSideURL;
                    _this.downloadImageFromUrl(_this.documentUrl[i].frontSideURL).then(function (img) {
                        _this.frontImg = _this.documentUrl[i].frontSideURL = img;
                        _this.imagePdf = _this.findFileExtentison(_this.memberResponseUrl[i].frontSideURL) ? _this.documentUrl[i].frontSideURL : '';
                        if (!_this.imagePdf) {
                            _this.imagePdf = _this.documentUrl[i].frontSideURL;
                        }
                        _this.documentUrl[i].frontSide = _this.imagePdf;
                        _this.findFileExtentison(_this.memberResponseUrl[i].frontSideURL) ? _this.urlToFile(_this.documentUrl[i].frontSideURL).then(function (image) {
                            _this.frontImg = _this.documentUrl[i].frontSideURL = image.img;
                        }) : '';
                    });
                }
                else {
                    _this.showFrontImg = false;
                    // this.documentUrl[i].frontSideURL = environment.uiTemplateBaseUrl + "/images/ind-default-image.png"
                }
                if (response.memberDocuments[i].backSideURL) {
                    _this.showBackImg = true;
                    _this.documentUrl[i].backSideURL = response.memberDocuments[i].backSideURL;
                    _this.memberResponseUrl[i].backSideURL = _this.documentUrl[i].backSideURL;
                    _this.downloadImageFromUrl(_this.documentUrl[i].backSideURL).then(function (img) {
                        _this.backImg = _this.documentUrl[i].backSideURL = img;
                        _this.imagePdf = _this.findFileExtentison(_this.memberResponseUrl[i].backSideURL) ? _this.documentUrl[i].backSideURL : '';
                        if (!_this.imagePdf) {
                            _this.imagePdf = _this.documentUrl[i].backSideURL;
                        }
                        _this.documentUrl[i].backSide = _this.imagePdf;
                        _this.findFileExtentison(_this.memberResponseUrl[i].backSideURL) ? _this.urlToFile(_this.documentUrl[i].backSideURL).then(function (image) {
                            _this.backImg = _this.documentUrl[i].backSideURL = image.img;
                        }) : '';
                    });
                }
                else {
                    _this.showBackImg = false;
                }
                if (response.memberDocuments[i].documentName) {
                    _this.documentUrl[i].documentName = response.memberDocuments[i].documentName;
                }
                j++;
            };
            for (var i = 0; i < resLength; i++) {
                _loop_1(i);
            }
        });
    };
    MemberDocumentsComponent.prototype.downloadImageFromUrl = function (imgUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var path, newres, img;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = new URL(imgUrl).pathname.slice(1);
                        return [4 /*yield*/, this._customerService.generateProfileImageSignedCDNURL(path).toPromise()];
                    case 1:
                        newres = _a.sent();
                        return [4 /*yield*/, newres.data[decodeURIComponent(path)]];
                    case 2:
                        img = _a.sent();
                        return [2 /*return*/, img];
                }
            });
        });
    };
    MemberDocumentsComponent.prototype.closePreviewImg = function () {
        this.previewImgModal.close();
    };
    MemberDocumentsComponent.prototype.urlToFile = function (fileLink) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch(fileLink)];
                    case 1:
                        res = _b.sent();
                        _a = this;
                        return [4 /*yield*/, res.blob()];
                    case 2:
                        _a.blobFile = _b.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                var pdfImgUrl = environment.uiTemplateBaseUrl + "/images/pdf.ico";
                                reader.addEventListener("load", function () {
                                    if (_this.blobFile.type == 'application/pdf') {
                                        var file = { 'img': pdfImgUrl, 'base64': reader.result };
                                        resolve(file);
                                    }
                                    else {
                                        resolve(reader.result);
                                    }
                                }, false);
                                reader.onerror = function () {
                                    return reject(_this);
                                };
                                reader.readAsDataURL(_this.blobFile);
                            })];
                }
            });
        });
    };
    MemberDocumentsComponent.prototype.findFileExtentison = function (fileName) {
        if (fileName) {
            var fileExtension = fileName.split('.').pop();
            return (fileExtension.includes("pdf") ? true : false);
        }
    };
    MemberDocumentsComponent.prototype.uploadFromLoacl = function (imgUrl) {
        var img = imgUrl;
        if (imgUrl) {
            this.previewImgModal.open();
            this.imagePdf = imgUrl;
            this.urlSafeEmbed = this.sanitizer.bypassSecurityTrustResourceUrl(this.imagePdf + '#zoom=100&toolbar=0');
        }
    };
    return MemberDocumentsComponent;
}());
export { MemberDocumentsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-documents.component.ts.pre-build-optimizer.js